import moment from 'moment';
import { onGlobalVarSet } from '@mm/utils';
import { NpsAttributes, SessionObject } from '@mm/state/interfaces/session';
import AuthenticatedController from '@mm/state/controllers/AuthenticatedController';
import { UserAttributes } from '@mm/state/model/CompanyUsersModel';
import { loadScript } from '../load-script';
import { IS_PROD_URL } from './constants';

const getNpsAttributes = (
  userId: number,
  companyId: number,
): Promise<{
  success: boolean;
  npsAttributes: NpsAttributes;
}> => {
  const path = `${API_URL}users/${userId}/nps_attributes?company_id=${companyId}`;
  return AuthenticatedController.get(path);
};

export const initNPSPlugin = async (session: SessionObject) => {
  const {
    createdAt,
    email,
    id,
    userAttributes = {} as Partial<UserAttributes>,
  } = session;
  const { activeCompanyId } = userAttributes;
  let npsAttributes;

  if (id && activeCompanyId) {
    const res = await getNpsAttributes(id, activeCompanyId);
    npsAttributes = res.npsAttributes;
  }

  if (IS_PROD_URL) {
    const createdAtTimeStamp = moment(createdAt).unix();

    const isTwoWeeksPastCreation =
      moment().diff(moment(createdAt), 'days') > 14;

    if (isTwoWeeksPastCreation) {
      (window as any).wootricSettings = {
        email,
        external_id: String(id),
        created_at: createdAtTimeStamp,
        account_token: 'NPS-b3b9b568',
        properties: npsAttributes,
      };

      loadScript({
        src: 'https://cdn.wootric.com/wootric-sdk.js',
        async: true,
      });

      const wootric = await onGlobalVarSet<any>('wootric');

      wootric('run');
    }
  }
};
